const uz = {
  // Common
  common: {
    loading: 'Yuklanmoqda...',
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: 'O\'chirish',
    edit: 'Tahrirlash',
    create: 'Yaratish',
    search: 'Qidirish',
    filter: 'Filtr',
    export: 'Eksport',
    import: 'Import',
    back: 'Orqaga',
    next: 'Keyingi',
    previous: 'Oldingi',
    submit: 'Yuborish',
    confirm: 'Tasdiqlash',
    close: 'Yopish',
    yes: 'Ha',
    no: 'Yo\'q',
    or: 'yoki',
    and: 'va',
    all: 'Hammasi',
    none: 'Hech qaysi',
    select: 'Tanlash',
    success: 'Muvaffaqiyat',
    error: 'Xato',
    warning: 'Ogohlantirish',
    info: 'Ma\'lumot',
    actions: 'Harakatlar',
    status: 'Holat',
    active: 'Faol',
    inactive: 'Nofaol',
    enabled: 'Yoqilgan',
    disabled: 'O\'chirilgan',
    settings: 'Sozlamalar',
    help: 'Yordam',
    logout: 'Chiqish',
    login: 'Kirish',
    signUp: 'Ro\'yxatdan o\'tish',
    email: 'Elektron pochta',
    password: 'Parol',
    username: 'Foydalanuvchi nomi',
    name: 'Ism',
    phone: 'Telefon',
    address: 'Manzil',
    description: 'Tavsif',
    date: 'Sana',
    time: 'Vaqt',
    total: 'Jami',
    amount: 'Miqdor',
    price: 'Narx',
    quantity: 'Soni',
    download: 'Yuklab olish',
    upload: 'Yuklash',
    refresh: 'Yangilash',
    view: 'Ko\'rish',
    details: 'Batafsil',
    more: 'Ko\'proq',
    less: 'Kamroq',
    new: 'YANGI',
    testimonials: 'Sharhlar',
    getStartedFree: 'Bepul boshlash',
    scheduleDemo: 'Demo rejalashtirish',
    simpleProcess: 'Oddiy jarayon',
    allRightsReserved: 'Barcha huquqlar himoyalangan.',
  },

  // Navigation
  nav: {
    home: 'Bosh sahifa',
    pricing: 'Narxlar',
    contact: 'Bog\'lanish',
    integrations: 'Integratsiyalar',
    docs: 'Hujjatlar',
    releases: 'Relizlar',
    bookDemo: 'Demo buyurtma',
    bookAppointment: 'Uchrashuv belgilash',
    solutions: 'Yechimlar',
    getStarted: 'Boshlash',
    dashboard: 'Boshqaruv paneli',
    voiceAgents: 'Ovozli agentlar',
    campaigns: 'Kampaniyalar',
    analytics: 'Tahlil',
    users: 'Foydalanuvchilar',
    settings: 'Sozlamalar',
    billing: 'Billing',
    reports: 'Hisobotlar',
    leads: 'Lidlar',
    files: 'Fayllar',
    cloneVoice: 'Ovoz klonlash',
    dialer: 'Avto-dialer',
    dnc: 'DNC ro\'yxati',
    agentMonitor: 'Agent monitoring',
  },

  // Home Page
  home: {
    heroTitle: 'Biznesingiz uchun sun\'iy intellektli ovozli agentlar',
    heroSubtitle: 'Tabiiy ovozli va murakkab suhbatlarni boshqaradigan aqlli ovozli AI bilan mijozlar bilan muloqotni avtomatlashtiring.',
    getStarted: 'Bepul boshlash',
    watchDemo: 'Demo ko\'rish',
    trustedBy: 'Yetakchi kompaniyalar ishonadi',
    features: {
      title: 'Kuchli imkoniyatlar',
      subtitle: 'Ovozli aloqalarni avtomatlashtirishga kerak bo\'lgan hamma narsa',
      aiVoice: {
        title: 'AI ovozli agentlar',
        description: 'Inson kabi suhbat qobiliyatiga ega, 24/7 qo\'ng\'iroqlarni qayta ishlaydigan tabiiy ovozli AI agentlar.',
      },
      autoDialer: {
        title: 'Avto-dialer',
        description: 'Aqlli sur\'at boshqaruvi va lid boshqaruvi bilan avtomatlashtirilgan chiquvchi qo\'ng\'iroq kampaniyalari.',
      },
      analytics: {
        title: 'Kengaytirilgan tahlil',
        description: 'Qo\'ng\'iroqlar samaradorligi, konversiya stavkalari va agent samaradorligi bo\'yicha real vaqtda tahlil.',
      },
      integrations: {
        title: 'Uzluksiz integratsiyalar',
        description: 'Ish jarayonlarini optimallashtirish uchun CRM, kalendar va boshqa vositalar bilan bog\'laning.',
      },
      voiceCloning: {
        title: 'Ovoz klonlash',
        description: 'Brend identifikatsiyasi va ohangingizga mos keladigan maxsus AI ovozlarini yarating.',
      },
      multiLanguage: {
        title: 'Ko\'p tilli qo\'llab-quvvatlash',
        description: 'Ingliz, rus va o\'zbek tillarini qo\'llab-quvvatlash.',
      },
    },
    cta: {
      title: 'Ovozli aloqalarni o\'zgartirishga tayyormisiz?',
      subtitle: 'Bugun bepul sinov muddatini boshlang va AI qila oladigan farqni ko\'ring.',
      button: 'Bepul sinov',
    },
  },

  // Auth
  auth: {
    login: 'Kirish',
    signIn: 'Tizimga kirish',
    signUp: 'Ro\'yxatdan o\'tish',
    logout: 'Chiqish',
    forgotPassword: 'Parolni unutdingizmi?',
    resetPassword: 'Parolni tiklash',
    createAccount: 'Hisob yaratish',
    alreadyHaveAccount: 'Hisobingiz bormi?',
    dontHaveAccount: 'Hisobingiz yo\'qmi?',
    emailPlaceholder: 'Elektron pochtangizni kiriting',
    passwordPlaceholder: 'Parolingizni kiriting',
    usernamePlaceholder: 'Foydalanuvchi nomini kiriting',
    rememberMe: 'Meni eslab qol',
    loginSuccess: 'Muvaffaqiyatli kirdingiz!',
    loginError: 'Noto\'g\'ri ma\'lumotlar. Qaytadan urinib ko\'ring.',
    logoutSuccess: 'Siz tizimdan chiqdingiz.',
    welcomeBack: 'Xush kelibsiz!',
    signInToContinue: 'Boshqaruv paneliga kirish uchun tizimga kiring',
    adminLogin: 'Admin kirish',
    clientLogin: 'Mijoz kirish',
    userLogin: 'Foydalanuvchi kirish',
  },

  // Dashboard
  dashboard: {
    title: 'Boshqaruv paneli',
    welcome: 'Xush kelibsiz, {name}!',
    overview: 'Umumiy ko\'rinish',
    recentActivity: 'So\'nggi faoliyat',
    quickActions: 'Tezkor harakatlar',
    stats: {
      totalCalls: 'Jami qo\'ng\'iroqlar',
      answeredCalls: 'Javob berilgan',
      missedCalls: 'O\'tkazib yuborilgan',
      avgDuration: 'O\'rtacha davomiylik',
      conversionRate: 'Konversiya stavkasi',
      activeAgents: 'Faol agentlar',
      activeCampaigns: 'Faol kampaniyalar',
      totalLeads: 'Jami lidlar',
    },
  },

  // Voice Agents
  voiceAgents: {
    title: 'Ovozli agentlar',
    createAgent: 'Agent yaratish',
    editAgent: 'Agentni tahrirlash',
    deleteAgent: 'Agentni o\'chirish',
    agentName: 'Agent nomi',
    agentVoice: 'Ovoz',
    agentLanguage: 'Til',
    agentScript: 'Skript',
    agentStatus: 'Holat',
    testAgent: 'Agentni sinash',
    testWithChat: 'Chat orqali sinash',
    testWithWeb: 'Veb-qo\'ng\'iroq',
    testWithPhone: 'Telefon qo\'ng\'iroq',
    voiceProvider: 'Ovoz provayderi',
    voicePreview: 'Ovozni tinglash',
    welcomeMessage: 'Salomlash xabari',
    conversationalFlow: 'Suhbat oqimi',
    transferSettings: 'Yo\'naltirish sozlamalari',
    enableTransfer: 'Qo\'ng\'iroqni yo\'naltirishni yoqish',
    transferNumber: 'Yo\'naltirish telefon raqami',
    noAgents: 'Ovozli agentlar hali yo\'q. Boshlash uchun birinchi agentni yarating.',
  },

  // Campaigns
  campaigns: {
    title: 'Kampaniyalar',
    createCampaign: 'Kampaniya yaratish',
    editCampaign: 'Kampaniyani tahrirlash',
    deleteCampaign: 'Kampaniyani o\'chirish',
    campaignName: 'Kampaniya nomi',
    campaignStatus: 'Holat',
    campaignType: 'Turi',
    startCampaign: 'Kampaniyani boshlash',
    pauseCampaign: 'Kampaniyani to\'xtatish',
    stopCampaign: 'Kampaniyani tugatish',
    contacts: 'Kontaktlar',
    dialed: 'Terilgan',
    answered: 'Javob berilgan',
    noAnswer: 'Javob yo\'q',
    busy: 'Band',
    failed: 'Muvaffaqiyatsiz',
    transferred: 'Yo\'naltirilgan',
    completed: 'Tugatilgan',
    progress: 'Jarayon',
    uploadContacts: 'Kontaktlarni yuklash',
    selectAgent: 'Ovozli agentni tanlash',
    dialDelay: 'Terish kechikishi (soniya)',
    maxConcurrent: 'Maksimal bir vaqtdagi qo\'ng\'iroqlar',
    noCampaigns: 'Kampaniyalar hali yo\'q. Qo\'ng\'iroqlarni boshlash uchun birinchi kampaniyani yarating.',
    health: 'Kampaniya holati',
  },

  // Analytics
  analytics: {
    title: 'Tahlil',
    overview: 'Umumiy ko\'rinish',
    callAnalytics: 'Qo\'ng\'iroqlar tahlili',
    voiceAnalytics: 'Ovoz tahlili',
    performanceMetrics: 'Samaradorlik ko\'rsatkichlari',
    dateRange: 'Sana oralig\'i',
    today: 'Bugun',
    yesterday: 'Kecha',
    last7Days: 'Oxirgi 7 kun',
    last30Days: 'Oxirgi 30 kun',
    thisMonth: 'Bu oy',
    lastMonth: 'O\'tgan oy',
    custom: 'Maxsus muddat',
    exportReport: 'Hisobotni eksport qilish',
    callVolume: 'Qo\'ng\'iroqlar hajmi',
    successRate: 'Muvaffaqiyat stavkasi',
    avgCallDuration: 'O\'rtacha qo\'ng\'iroq davomiyligi',
    peakHours: 'Eng gavjum soatlar',
  },

  // Users
  users: {
    title: 'Foydalanuvchilar',
    createUser: 'Foydalanuvchi yaratish',
    editUser: 'Foydalanuvchini tahrirlash',
    deleteUser: 'Foydalanuvchini o\'chirish',
    userName: 'Foydalanuvchi nomi',
    userEmail: 'Elektron pochta',
    userRole: 'Rol',
    userStatus: 'Holat',
    lastLogin: 'Oxirgi kirish',
    assignedPhone: 'Belgilangan telefon',
    availability: 'Mavjudlik',
    available: 'Mavjud',
    busy: 'Band',
    offline: 'Oflayn',
    noUsers: 'Foydalanuvchilar hali yo\'q. Birinchi foydalanuvchini qo\'shing.',
  },

  // Settings
  settings: {
    title: 'Sozlamalar',
    general: 'Umumiy',
    account: 'Hisob',
    notifications: 'Bildirishnomalar',
    security: 'Xavfsizlik',
    integrations: 'Integratsiyalar',
    billing: 'Billing',
    api: 'API',
    timezone: 'Vaqt mintaqasi',
    language: 'Til',
    theme: 'Mavzu',
    darkMode: 'Qorong\'u rejim',
    lightMode: 'Yorug\' rejim',
    saveChanges: 'O\'zgarishlarni saqlash',
    changePassword: 'Parolni o\'zgartirish',
    currentPassword: 'Joriy parol',
    newPassword: 'Yangi parol',
    confirmPassword: 'Parolni tasdiqlang',
  },

  // Integrations
  integrations: {
    title: 'Integratsiyalar',
    subtitle: 'Sevimli vositalaringiz va platformalaringiz bilan ulaning',
    ecosystem: 'Ekotizim',
    connected: 'Ulangan',
    notConnected: 'Ulanmagan',
    connect: 'Ulash',
    disconnect: 'Uzish',
    configure: 'Sozlash',
    testConnection: 'Ulanishni tekshirish',
    apiKey: 'API kaliti',
    apiSecret: 'API maxfiy kaliti',
    webhookUrl: 'Webhook URL',
    categories: {
      crm: 'CRM',
      calendar: 'Kalendar',
      messaging: 'Xabarlar',
      analytics: 'Tahlil',
      contactCenter: 'Aloqa markazi',
      other: 'Boshqa',
    },
  },

  // Billing
  billing: {
    title: 'Billing',
    currentPlan: 'Joriy tarif',
    usage: 'Foydalanish',
    invoices: 'Hisob-fakturalar',
    paymentMethods: 'To\'lov usullari',
    upgradePlan: 'Tarifni yaxshilash',
    cancelSubscription: 'Obunani bekor qilish',
    billingHistory: 'To\'lov tarixi',
    nextBillingDate: 'Keyingi to\'lov sanasi',
    minutesUsed: 'Ishlatilgan daqiqalar',
    minutesRemaining: 'Qolgan daqiqalar',
  },

  // Leads
  leads: {
    title: 'Lidlar',
    createLead: 'Lid yaratish',
    importLeads: 'Lidlarni import qilish',
    exportLeads: 'Lidlarni eksport qilish',
    leadName: 'Lid nomi',
    leadPhone: 'Telefon',
    leadEmail: 'Elektron pochta',
    leadStatus: 'Holat',
    leadSource: 'Manba',
    new: 'Yangi',
    contacted: 'Bog\'lanilgan',
    qualified: 'Malakali',
    converted: 'Konversiya qilingan',
    lost: 'Yo\'qotilgan',
    noLeads: 'Lidlar hali yo\'q. Lidlarni import qiling yoki yarating.',
  },

  // Files
  files: {
    title: 'Fayllar',
    uploadFile: 'Fayl yuklash',
    deleteFile: 'Faylni o\'chirish',
    fileName: 'Fayl nomi',
    fileSize: 'Hajmi',
    fileType: 'Turi',
    uploadedAt: 'Yuklangan',
    noFiles: 'Fayllar hali yuklanmagan.',
    dragDrop: 'Fayllarni shu yerga tashlang yoki tanlash uchun bosing',
    supportedFormats: 'Qo\'llab-quvvatlanadigan formatlar: CSV, XLS, XLSX',
  },

  // Errors
  errors: {
    somethingWentWrong: 'Nimadir noto\'g\'ri ketdi. Qaytadan urinib ko\'ring.',
    pageNotFound: 'Sahifa topilmadi',
    unauthorized: 'Sizda bu sahifaga kirish huquqi yo\'q.',
    sessionExpired: 'Sessiya muddati tugadi. Qaytadan kiring.',
    networkError: 'Tarmoq xatosi. Ulanishingizni tekshiring.',
    validationError: 'Kiritilgan ma\'lumotlarni tekshiring.',
    serverError: 'Server xatosi. Keyinroq urinib ko\'ring.',
  },

  // Success Messages
  success: {
    saved: 'O\'zgarishlar saqlandi!',
    created: 'Muvaffaqiyatli yaratildi!',
    updated: 'Muvaffaqiyatli yangilandi!',
    deleted: 'Muvaffaqiyatli o\'chirildi!',
    uploaded: 'Fayl yuklandi!',
    imported: 'Ma\'lumotlar import qilindi!',
    exported: 'Ma\'lumotlar eksport qilindi!',
    copied: 'Buferga nusxalandi!',
  },

  // Confirmation
  confirm: {
    delete: 'Haqiqatan ham buni o\'chirmoqchimisiz?',
    cancel: 'Haqiqatan ham bekor qilmoqchimisiz?',
    logout: 'Haqiqatan ham chiqmoqchimisiz?',
    discard: 'Saqlanmagan o\'zgarishlarni bekor qilasizmi?',
  },

  // Footer
  footer: {
    copyright: '© {year} AIConneqtors. Barcha huquqlar himoyalangan.',
    privacy: 'Maxfiylik siyosati',
    terms: 'Foydalanish shartlari',
    contact: 'Bog\'lanish',
    about: 'Biz haqimizda',
    description: 'No-code vositalar va API bilan suhbat AI tizimlarini yarating, sinab ko\'ring va ishga tushiring.',
    product: 'Mahsulot',
    features: 'Funksiyalar',
    resources: 'Resurslar',
    apiReference: 'API hujjatlari',
    blog: 'Blog',
    helpCenter: 'Yordam markazi',
    company: 'Kompaniya',
    cookies: 'Cookies',
  },

  // Language Selector
  languageSelector: {
    title: 'Tilni tanlang',
    current: 'Joriy til',
  },

  // Header
  header: {
    announcement: 'Endi AIConneqtors-da telefon raqamlarini sotib olishingiz mumkin!',
    viewUpdate: 'Batafsil',
    admin: 'Admin',
  },

  // Hero Section
  hero: {
    title: 'O\'zingizning',
    free: 'Bepul',
    voiceAI: 'Ovozli AI',
    assistant: 'Yordamchingizni yarating',
    subtitle: 'Ishonchli ovozli AI yordamchilarini yarating, sinab ko\'ring va ishga tushiring',
    placeholder: 'Ideal ovozli AI yordamchingizni tasvirlab bering',
    guidedFlow: 'Bosqichma-bosqich',
    createAgent: 'Agent yaratish',
    chooseUseCase: 'Foydalanish holatini tanlang',
    useCases: ['Lead yaratish', 'Uchrashuvlar', 'Qo\'llab-quvvatlash', 'Muzokaralar', 'Yig\'imlar']
  },

  // Core Capabilities
  capabilities: {
    title: 'Asosiy imkoniyatlar',
    heading: 'Nima uchun AIConneqtors',
    voiceAI: 'Ovozli AI',
    subtitle: 'Ovozli AI yordamchilarini yaratish, joylashtirish va kengaytirish uchun kuchli funksiyalar',
    selectLanguage: 'Tilni tanlang',
    features: [
      {
        icon: 'Languages',
        title: 'Ko\'p tilli',
        description: 'Butun dunyo bo\'ylab 50+ tilda foydalanuvchilarga xizmat qiling'
      },
      {
        icon: 'ArrowUpRight',
        title: 'Chiquvchi masshtabi',
        description: 'Lead yaratish, eslatmalar va to\'lovlarni avtomatlashtiring'
      },
      {
        icon: 'Clock',
        title: '24/7 Kiruvchi',
        description: 'Buyurtmalar va so\'rovlarni kechayu kunduz boshqaring'
      },
      {
        icon: 'Plug',
        title: 'Integratsiyalar',
        description: 'CRM, Sheets, Slack, n8n bilan integratsiya qiling'
      },
      {
        icon: 'GraduationCap',
        title: 'Tez o\'rgatish',
        description: 'AI-ni o\'z qo\'ng\'iroq yozuvlaringiz bilan o\'rgating'
      },
      {
        icon: 'Phone',
        title: 'Telefon raqamlari',
        description: 'AQSh (+1) raqamlarini darhol sotib oling'
      }
    ]
  },

  // User Dashboard
  userDashboard: {
    title: 'Agent portali',
    welcome: 'Xush kelibsiz',
    welcomeSubtitle: 'AI agentlaridan yo\'naltirilgan qo\'ng\'iroqlarni qabul qiling va boshqaring',
    softphoneSetup: 'Softfon sozlamalari (Zoiper/Linphone)',
    yourPhone: 'Sizning telefoningiz',
    notAssigned: 'Belgilanmagan',
    downloadZoiper: 'Zoiper yuklab olish',
    sipDescription: 'Bu SIP ma\'lumotlarini Zoiper, Linphone yoki boshqa SIP-mos softfonlarni sozlash uchun ishlating.',
    sipServer: 'SIP Server / Domen',
    username: 'Foydalanuvchi nomi / SIP ID',
    password: 'Parol',
    outboundProxy: 'Chiquvchi proksi (ixtiyoriy)',
    setupInstructions: 'Sozlash ko\'rsatmalari',
    callsWillBeTransferred: 'AI yo\'naltirish niyatini aniqlasa, qo\'ng\'iroqlar softfoningizga yo\'naltiriladi',
    availability: 'Mavjudlik',
    available: 'Mavjud',
    busy: 'Band',
    callsToday: 'Bugungi qo\'ng\'iroqlar',
    minutesUsed: 'Ishlatilgan daqiqalar',
    plan: 'Tarif',
    voiceAgents: 'Ovozli AI agentlaringiz',
    noAgentsAssigned: 'Agentlar belgilanmagan',
    contactAdmin: 'Agentlarni tayinlash uchun administratoringizga murojaat qiling',
    testCall: 'Test qo\'ng\'iroq',
    recentCalls: 'So\'nggi qo\'ng\'iroqlar',
    upgradePlan: 'Tarifni yaxshilash',
    moreMinutes: 'Ko\'proq daqiqalar oling va premium funksiyalarni oching',
    viewAllPlans: 'Barcha tariflar',
    lowMinutes: 'Kam daqiqalar! Faqat',
    minRemaining: 'daqiqa qoldi',
    upgrade: 'Yaxshilash',
    demoMode: 'Demo rejim',
    callsSimulated: 'Qo\'ng\'iroqlar simulyatsiya qilingan. Haqiqiy qo\'ng\'iroqlar uchun Telnyx API kaliti kerak.',
    phoneToCall: 'Qo\'ng\'iroq qilish raqami',
  },

  // Desktop Notifications
  notifications: {
    enableTitle: 'Bildirishnomalarni yoqish',
    enableDescription: 'Bu varaq fonda bo\'lsa ham, kiruvchi qo\'ng\'iroqlar haqida xabar oling',
    enable: 'Yoqish',
    incomingCall: 'Kiruvchi qo\'ng\'iroq',
    callFrom: 'Qo\'ng\'iroq',
    clickToAnswer: 'Javob berish uchun bosing',
  },

  // Zoiper Setup Steps
  zoiperSetup: {
    download: 'Zoiper-ni yuklab oling va o\'rnating',
    openZoiper: 'Zoiper-ni oching va "Create Account" → "Yes" (I have credentials) bosing',
    enterCredentials: 'Yuqoridagi foydalanuvchi nomi va parolni kiriting',
    forProvider: 'Provider uchun kiriting:',
    skipOptional: 'Ixtiyoriy sozlamalarni o\'tkazib yuboring va "Create" bosing',
    waitReady: '"Ready" holati yoki yashil ko\'rsatkich paydo bo\'lishini kuting',
    keepRunning: 'Kiruvchi qo\'ng\'iroqlarni qabul qilish uchun Zoiper-ni ishga tushiring',
  },

  // Linphone Setup Steps
  linphoneSetup: {
    download: 'Linphone-ni yuklab oling',
    goToSettings: 'Settings → Account → Add Account-ga o\'ting',
    selectSIP: '"I have a SIP account"-ni tanlang',
    enterDetails: 'Foydalanuvchi nomi, parol va domen (sip.telnyx.com) kiriting',
    saveWait: 'Saqlang va ro\'yxatdan o\'tishni kuting',
  },

  // Sidebar
  sidebar: {
    clientPortal: 'Mijoz portali',
    client: 'Mijoz',
    clientAdmin: 'Mijoz administratori',
    plan: 'Tarif',
    voiceAiSetup: 'OVOZLI AI SOZLAMALARI',
    operationsMonitoring: 'OPERATSIYALAR VA MONITORING',
    monitoring: 'MONITORING',
    management: 'BOSHQARUV',
    accountBilling: 'HISOB VA BILLING',
    phoneNumbers: 'Telefon raqamlari',
    callLogs: 'Qo\'ng\'iroqlar tarixi',
    campaignHealth: 'Kampaniya holati',
    voiceAnalytics: 'Ovoz tahlili',
    usageQuotas: 'Foydalanish va kvotalar',
    dialerPortal: 'Dialer portali',
    restrictedFeatures: 'Ba\'zi funksiyalar cheklangan bo\'lishi mumkin',
    telnyxSettings: 'Telnyx sozlamalari',
  },

  // Client Dashboard
  clientDashboard: {
    totalUsers: 'Jami foydalanuvchilar',
    activeAgents: 'Faol agentlar',
    totalCalls: 'Jami qo\'ng\'iroqlar',
    subtitle: 'Bu boshqaruv panelidan foydalanuvchilar va ovozli AI agentlaringizni boshqaring',
    recentAgents: 'So\'nggi ovozli agentlar',
    noAgentsYet: 'Hali agentlar yo\'q. Birinchi ovozli agentni yarating.',
    createAgentDesc: 'Yangi ovozli AI yordamchisini sozlang',
    manageUsers: 'Foydalanuvchilarni boshqarish',
    manageUsersDesc: 'Jamoa a\'zolarini qo\'shing yoki tahrirlang',
  },

  // Voice Agents Page
  voiceAgents: {
    title: 'Ovozli AI agentlar',
    subtitle: 'Ovozli AI yordamchilaringizni yarating va boshqaring',
    createAgent: 'Agent yaratish',
    refresh: 'Yangilash',
    agentQuota: 'Agent kvotasi',
    noSlotsRemaining: 'Slotlar tugadi. Yangilash uchun administratoringizga murojaat qiling.',
    slotsRemaining: 'slot qoldi',
    searchPlaceholder: 'Agentlarni nom yoki til bo\'yicha qidiring...',
    noAgentsFound: 'Agentlar topilmadi. Boshlash uchun "Agent yaratish" ni bosing.',
    loadingAgents: 'Agentlar yuklanmoqda...',
    editAgent: 'Agentni tahrirlash',
    viewScript: 'Skriptni ko\'rish',
    deleteAgent: 'Agentni o\'chirish',
    confirmDelete: 'Haqiqatan ham bu agentni o\'chirmoqchimisiz?',
    agentDeleted: 'Agent muvaffaqiyatli o\'chirildi',
    agentCreated: 'Agent muvaffaqiyatli yaratildi',
    agentUpdated: 'Agent muvaffaqiyatli yangilandi',
    limitReached: 'Agent limiti tugadi. Yangilash uchun administratoringizga murojaat qiling.',
    calls: 'qo\'ng\'iroq',
    status: 'Holat',
    language: 'Til',
    voice: 'Ovoz',
    script: 'Skript',
    greeting: 'Salomlashish',
    description: 'Tavsif',
    name: 'Nom',
    advancedSettings: 'Kengaytirilgan sozlamalar',
    fullEditor: 'To\'liq muharrir',
  },

  // Campaigns Page
  campaigns: {
    title: 'Avto-qo\'ng\'iroq kampaniyalari',
    subtitle: 'Kontakt ro\'yxatlarini yuklang va AI agentlar bilan avtomatik qo\'ng\'iroq qiling',
    newCampaign: 'Yangi kampaniya',
    createCampaign: 'Kampaniya yaratish',
    noCampaigns: 'Kampaniyalar yo\'q',
    createFirstCampaign: 'Boshlash uchun birinchi avto-qo\'ng\'iroq kampaniyangizni yarating',
    contacts: 'kontakt',
    agent: 'Agent',
    delay: 'kechikish',
    scheduled: 'Rejalashtirilgan',
    daily: 'Kunlik',
    weekly: 'Haftalik',
    monthly: 'Oylik',
    nextRun: 'Keyingi',
    runs: 'ishga tushirish',
    progress: 'Jarayon',
    viewDetails: 'Batafsil',
    start: 'Boshlash',
    pause: 'Pauza',
    stop: 'To\'xtatish',
    delete: 'O\'chirish',
    confirmDelete: 'Haqiqatan ham bu kampaniyani o\'chirmoqchimisiz?',
    noDescription: 'Tavsif yo\'q',
    filterAll: 'Hammasi',
    filterDraft: 'Qoralama',
    filterScheduled: 'Rejalashtirilgan',
    filterRunning: 'Faol',
    filterPaused: 'Pauza',
    filterStopped: 'To\'xtatilgan',
    filterCompleted: 'Tugallangan',
    filterCancelled: 'Bekor qilingan',
  },

  // Analytics Page
  analytics: {
    title: 'Tahlil paneli',
    subtitle: 'Qo\'ng\'iroq metrikalari va samaradorlik ko\'rsatkichlari',
    lastDays: 'Oxirgi {days} kun',
    last7Days: 'Oxirgi 7 kun',
    last14Days: 'Oxirgi 14 kun',
    last30Days: 'Oxirgi 30 kun',
    last90Days: 'Oxirgi 90 kun',
    totalCalls: 'Jami qo\'ng\'iroqlar',
    answered: 'Javob berilgan',
    avgDuration: 'O\'rtacha davomiylik',
    talkTime: 'Gaplashish vaqti',
    outbound: 'Chiquvchi',
    inbound: 'Kiruvchi',
    answeredCalls: 'Javob berilgan qo\'ng\'iroqlar',
    answerRate: 'Javob foizi',
    peakHour: 'Eng yuqori soat',
    callOutcomes: 'Qo\'ng\'iroq natijalari',
    noAnswer: 'Javob yo\'q',
    busy: 'Band',
    failed: 'Muvaffaqiyatsiz',
    durationDistribution: 'Davomiylik taqsimoti',
    under1Min: '1 daqiqadan kam',
    oneToFiveMins: '1-5 daqiqa',
    fiveToTenMins: '5-10 daqiqa',
    overTenMins: '10+ daqiqa',
    campaignPerformance: 'Kampaniya samaradorligi',
    noCampaigns: 'Kampaniyalar topilmadi',
    recentCallsWithRecordings: 'Yozuvli so\'nggi qo\'ng\'iroqlar',
    noCallsFound: 'Yozuvli qo\'ng\'iroqlar topilmadi',
    playRecording: 'Yozuvni ijro etish',
    viewTranscript: 'Transkriptsiyani ko\'rish',
    loading: 'Tahlil yuklanmoqda...',
    retry: 'Qayta urinish',
    failedToLoad: 'Tahlil ma\'lumotlarini yuklash muvaffaqiyatsiz',
  },

  // Telnyx Settings
  telnyxSettings: {
    title: 'Telnyx sozlamalari',
    subtitle: 'Qo\'ng\'iroqlar va billing ajratish uchun o\'z Telnyx akkauntingizdan foydalaning',
    configTitle: 'Telnyx hisob ma\'lumotlaringiz',
    callerID: 'Qo\'ng\'iroq qiluvchi ID',
    enableOwn: 'O\'z Telnyx akkauntimni ishlatish',
    enableDesc: 'Yoqilganda, kampaniyalar tizim sozlamalari o\'rniga sizning Telnyx ma\'lumotlaringizni ishlatadi',
    apiKey: 'API kaliti',
    apiKeyPlaceholder: 'Telnyx API kalitingizni kiriting',
    apiKeyRequired: 'API kaliti talab qilinadi',
    apiKeyHelp: 'API kalitini oling',
    connectionId: 'Ulanish ID (Call Control App)',
    connectionIdPlaceholder: 'Call Control Application ID kiriting',
    connectionIdHelp: 'Telnyx-dagi Call Control ilovangizning ID raqami',
    phoneNumber: 'Telefon raqami',
    phoneNumberHelp: 'Telnyx akkauntingizdagi chiquvchi qo\'ng\'iroqchi ID raqami',
    verified: 'Tasdiqlangan',
    notVerified: 'Tasdiqlanmagan',
    verify: 'Ma\'lumotlarni tekshirish',
    useSystem: 'Tizim sozlamalarini ishlatish',
    saveSuccess: 'Telnyx konfiguratsiyasi muvaffaqiyatli saqlandi',
    saveError: 'Konfiguratsiyani saqlash muvaffaqiyatsiz',
    verifySuccess: 'Ma\'lumotlar muvaffaqiyatli tasdiqlandi',
    verifyFailed: 'Ma\'lumotlarni tasdiqlash muvaffaqiyatsiz',
    verifyError: 'Ma\'lumotlarni tekshirishda xato',
    deleteSuccess: 'Konfiguratsiya o\'chirildi. Tizim sozlamalari ishlatilmoqda.',
    deleteError: 'Konfiguratsiyani o\'chirish muvaffaqiyatsiz',
    confirmDelete: 'Telnyx konfiguratsiyangizni o\'chirib, tizim sozlamalarini ishlatmoqchimisiz?',
    helpTitle: 'Bu qanday ishlaydi',
    help1: '1. Telnyx API kaliti, ulanish ID va telefon raqamingizni kiriting',
    help2: '2. Ma\'lumotlarni xavfsiz saqlash uchun "Saqlash" tugmasini bosing',
    help3: '3. Barcha kampaniyalaringiz endi billing uchun o\'z Telnyx akkauntingizni ishlatadi',
  },

  // Voice Analytics Dashboard
  voiceAnalytics: {
    title: 'Ovozli tahlil',
    subtitle: 'Kengaytirilgan qo\'ng\'iroq tahlili va insaytlar',
    exportPdf: 'PDF eksport',
    tabOverview: 'Umumiy',
    tabTalkTime: 'Gaplashish vaqti',
    tabKeywords: 'Kalit so\'zlar',
    tabOutcomes: 'Natijalar',
    tabAiInsights: 'AI insaytlar',
    tabPerformance: 'Samaradorlik',
    tabCompare: 'Taqqoslash',
    totalCalls: 'Jami qo\'ng\'iroqlar',
    talkTime: 'Gaplashish vaqti',
    answerRate: 'Javob foizi',
    transferRate: 'Transfer foizi',
    hourlyDistribution: 'Soatlik qo\'ng\'iroq taqsimoti',
    durationDistribution: 'Davomiylik taqsimoti',
    dailyTrends: 'Kunlik trendlar',
    peakAnalysis: 'Eng yuqori tahlil',
    peakHour: 'Eng yuqori soat',
    peakDay: 'Eng yuqori kun',
    callsAtPeak: 'qo\'ng\'iroq',
    avgDuration: 'O\'rtacha davomiylik',
    minDuration: 'Min davomiylik',
    maxDuration: 'Maks davomiylik',
    topKeywords: 'Top kalit so\'zlar',
    keywordsOverall: 'Umumiy',
    keywordsCustomer: 'Mijozlardan',
    keywordsAgent: 'Agentlardan',
    phraseAnalysis: 'Ibora tahlili',
    transferRequests: 'Transfer so\'rovlari',
    positiveSentiment: 'Ijobiy kayfiyat',
    negativeSentiment: 'Salbiy kayfiyat',
    outcomeDistribution: 'Natija taqsimoti',
    statusDistribution: 'Holat taqsimoti',
    agentPerformance: 'Agent samaradorligi',
    conversionFunnel: 'Konversiya hunisi',
    dialed: 'Terilgan',
    answered: 'Javob berilgan',
    completed: 'Tugallangan',
    customerSatisfaction: 'Mijoz qoniqishi',
    topIntent: 'Top niyat',
    objectionRate: 'E\'tiroz foizi',
    intentTrends: 'Niyat trendlari',
    topObjections: 'Top e\'tirozlar',
    noDataAvailable: 'Ma\'lumot yo\'q',
    noDataMessage: 'Qo\'ng\'iroq ma\'lumotlaringiz bo\'lganda AI insaytlar shu yerda paydo bo\'ladi.',
    bestTimeSlots: 'Eng yaxshi vaqt oraligi',
    performanceByLanguage: 'Til bo\'yicha samaradorlik',
    calls: 'qo\'ng\'iroq',
    successRate: 'muvaffaqiyat foizi',
  },

  // FAQ Section
  faq: {
    title: 'Ko\'p so\'raladigan savollar',
    subtitle: 'AIConneqtors platformasi haqida umumiy savollar',
    questions: [
      {
        question: 'Ovozli AI-agentni qanchalik tez yaratishim mumkin?',
        answer: 'AIConneqtors-da to\'liq ishlaydigan ovozli AI-agentni 5 daqiqadan kamroq vaqt ichida yaratishingiz mumkin. Faqat tasvirlab bering, ovozni tanlang va ishga tushiring. Dasturlash talab etilmaydi.'
      },
      {
        question: 'Menga texnik yoki dasturlash bilimi kerakmi?',
        answer: 'Umuman yo\'q. AIConneqtors hamma uchun yaratilgan - biznes egalaridan tortib dasturchilargacha. Siz AI-agentlarni bitta qator kod yozmasdan yaratishingiz, sinashingiz va joylashtirishingiz mumkin.'
      },
      {
        question: 'Qanday turdagi ovozli AI-agentlarni yaratishim mumkin?',
        answer: 'AIConneqtors-da siz mijozlarga xizmat ko\'rsatish botlarini, lead generatsiya agentlarini, uchrashuv rejalashtiruvchilarini, savdo yordamchilarini, IVR tizimlarini va boshqalarni yaratishingiz mumkin.'
      },
      {
        question: 'AI-agent qanday ovoz chiqarishi va javob berishini sozlashim mumkinmi?',
        answer: 'Albatta. AIConneqtors sizga ko\'plab tabiiy ovozlar, ohanglar, nutq tezliklari va hissiy uslublardan tanlash imkonini beradi.'
      },
      {
        question: 'Agentimni yaratgandan keyin nima bo\'ladi?',
        answer: 'AIConneqtors-da yaratgandan so\'ng, agentingizni darhol sinashingiz, qo\'ng\'iroqlarda yoki saytingizda joylashtirishingiz va real vaqtda analitikani kuzatishingiz mumkin.'
      },
      {
        question: 'Bepul sinov yoki demo mavjudmi?',
        answer: 'Ha. Birinchi agentingizni yaratish va platformani sinab ko\'rish uchun AIConneqtors-da bepul sinov uchun ro\'yxatdan o\'tishingiz mumkin.'
      },
    ]
  },

  // How It Works Section
  howItWorks: {
    title: 'Bu qanday ishlaydi',
    subtitle: 'AIConneqtors bilan uchta oddiy qadamda boshlang',
    stepButtons: [
      { step: 1, icon: 'PenLine', title: 'Yozing', description: 'Qanday ovozli AI yordamchi xohlashingizni tasvirlab bering' },
      { step: 2, icon: 'FlaskConical', title: 'Sinang', description: 'Yordamchingizni sinab ko\'ring va qanday ishlashini ko\'ring' },
      { step: 3, icon: 'Puzzle', title: 'Funksiyalar qo\'shing', description: 'Suhbat va drag-and-drop orqali yaxshilang' },
      { step: 4, icon: 'Rocket', title: 'Joylashtiring', description: 'Yordamchingizni foydalanuvchilarga taqdim eting' },
      { step: 5, icon: 'LineChart', title: 'Kuzating', description: 'Ishlashni kuzating va yaxshilashlar qiling' }
    ],
    steps: [
      {
        number: '01',
        title: 'Agentingizni yarating',
        description: 'Tabiiy tilda ideal AI-yordamchingizni tasvirlab bering. Ovoz, shaxsiyat va xatti-harakatni tanlang.'
      },
      {
        number: '02',
        title: 'Sozlang va sinang',
        description: 'Qo\'ng\'iroq oqimlarini, integratsiyalarni sozlang va agentingizni jonli efirga chiqishdan oldin haqiqiy suhbatlarda sinab ko\'ring.'
      },
      {
        number: '03',
        title: 'Ishga tushiring va kengaytiring',
        description: 'Agentingizni darhol ishga tushiring. To\'liq analitika bilan minglab qo\'ng\'iroqlarni bir vaqtning o\'zida boshqaring.'
      }
    ],
    stepDetails: {
      1: {
        title: 'Tabiiy tilda ovozli AI yordamchilarini yarating',
        subtitle: 'Ovozli AI yordamchingiz nima qilishini tasvirlab bering, biz uni siz uchun yaratamiz.',
        features: [
          {
            icon: 'MessageCircle',
            title: 'Suhbat orqali yaratish',
            description: 'Yordamchingizni tabiiy suhbat orqali yarating — platformamiz bilan kerakli narsangiz haqida gaplashing.'
          },
          {
            icon: 'MousePointerSquare',
            title: 'Drag-and-Drop interfeys',
            description: 'Yordamchingiz imkoniyatlarini intuitiv sudrab qo\'yish tahrirlovchisi bilan sozlang.'
          },
          {
            icon: 'FileText',
            title: 'Tayyor shablonlar',
            description: 'Sanoatga xos shablonlardan boshlang va ehtiyojlaringizga moslashtiring.'
          }
        ]
      },
      2: {
        title: 'Ovozli AI yordamchingizni sinang',
        subtitle: 'Joylashtirishdan oldin yordamchingizni real vaqtda ko\'rib chiqing va sinab ko\'ring.',
        features: [
          {
            icon: 'Mic',
            title: 'Jonli ovoz sinovi',
            description: 'Yordamchingizni haqiqiy ovozli buyruqlar bilan sinab ko\'ring va javoblarni real vaqtda eshiting.'
          },
          {
            icon: 'MessageSquare',
            title: 'Suhbat simulyatsiyasi',
            description: 'Tabiiy oqim va aniq javoblarni ta\'minlash uchun to\'liq suhbatlarni simulyatsiya qiling.'
          },
          {
            icon: 'ClipboardCheck',
            title: 'Sifat nazorati',
            description: 'Yordamchingiz chekka holatlarni to\'g\'ri boshqarishini tekshirish uchun avtomatlashtirilgan testlarni ishga tushiring.'
          }
        ]
      },
      3: {
        title: 'Tizimlaringiz bilan integratsiya qiling',
        subtitle: 'Ovozli AI yordamchingizni mavjud vositalaringiz va ish oqimlaringiz bilan ulang.',
        features: [
          {
            icon: 'Zap',
            title: 'API integratsiyasi',
            description: 'Keng qamrovli REST API va webhooklarimiz yordamida istalgan tizimga ulaning.'
          },
          {
            icon: 'Database',
            title: 'CRM sinxronizatsiyasi',
            description: 'Qo\'ng\'iroq ma\'lumotlari va mijoz ma\'lumotlarini CRM bilan avtomatik sinxronlang.'
          },
          {
            icon: 'GitBranch',
            title: 'Ish oqimi avtomatizatsiyasi',
            description: 'Suhbat natijalari asosida boshqa ilovalarda harakatlarni ishga tushiring.'
          }
        ]
      },
      4: {
        title: 'Joylashtirish va kengaytirish',
        subtitle: 'Yordamchingizni ishga tushiring va minglab bir vaqtdagi qo\'ng\'iroqlarni boshqaring.',
        features: [
          {
            icon: 'Phone',
            title: 'Telefon raqamlarini sozlash',
            description: 'Ajratilgan telefon raqamlarini oling yoki mavjud raqamlaringizni darhol ulang.'
          },
          {
            icon: 'Globe',
            title: 'Global joylashtirish',
            description: 'Butun dunyo bo\'ylab past kechikishli qo\'ng\'iroqlar uchun bir nechta mintaqalarga joylashtiring.'
          },
          {
            icon: 'Share2',
            title: 'Ko\'p kanalli qo\'llab-quvvatlash',
            description: 'Yordamchingizni veb, mobil va xabar platformalariga kengaytiring.'
          }
        ]
      },
      5: {
        title: 'Monitoring va optimallashtirish',
        subtitle: 'Ishlashni kuzating va ovozli AI yordamchingizni doimiy ravishda yaxshilang.',
        features: [
          {
            icon: 'BarChart2',
            title: 'Real vaqt analitikasi',
            description: 'Qo\'ng\'iroq hajmlari, muvaffaqiyat ko\'rsatkichlari va mijozlar qoniqishini jonli kuzating.'
          },
          {
            icon: 'FileSearch',
            title: 'Suhbat tahlili',
            description: 'Mijozlar ehtiyojlarini tushunish va javoblarni yaxshilash uchun transkriptlarni tahlil qiling.'
          },
          {
            icon: 'TrendingUp',
            title: 'AI o\'rganishi',
            description: 'Yordamchingiz haqiqiy suhbatlar asosida doimiy ravishda takomillashadi.'
          }
        ]
      }
    }
  },

  // Key Features Section
  keyFeatures: {
    title: 'Asosiy xususiyatlar',
    subtitle: 'Kuchli ovozli AI yechimlarini yaratish uchun zarur bo\'lgan hamma narsa',
    features: [
      {
        title: 'Tabiiy ovoz sintezi',
        description: 'Inson kabi eshitiladigan, ohang, tezlik va his-tuyg\'ularni sozlash mumkin bo\'lgan ultra-real AI ovozlari.'
      },
      {
        title: 'Aqlli qo\'ng\'iroq yo\'naltirish',
        description: 'Niyat, kayfiyat va mijoz tarixiga asoslangan intellektual yo\'naltirish.'
      },
      {
        title: 'Real vaqt analitikasi',
        description: 'Qo\'ng\'iroq ko\'rsatkichlari, konversiya darajalari va agent samaradorligini kuzatuvchi jonli panellar.'
      },
      {
        title: 'CRM integratsiyasi',
        description: 'Mavjud vositalaringiz bilan - Salesforce, HubSpot va boshqalar bilan muammosiz ulanish.'
      },
      {
        title: 'Ko\'p tilli qo\'llab-quvvatlash',
        description: 'Bir nechta tillarni ravon gapira oladigan va tushunadigan AI-agentlar.'
      },
      {
        title: 'Qo\'ng\'iroqni yozib olish va transkripsiya',
        description: 'O\'rganish va muvofiqlik uchun har bir suhbatni avtomatik yozib olish va transkripsiya qilish.'
      }
    ]
  },

  // Testimonials Section
  testimonials: {
    title: 'Mijozlarimiz nima deydi',
    subtitle: 'Dunyo bo\'ylab kompaniyalar tomonidan ishoniladi',
    items: [
      {
        quote: 'AIConneqtors mijozlarga xizmat ko\'rsatishimizni o\'zgartirdi. Biz 3 baravar ko\'proq qo\'ng\'iroqlarni yaxshiroq qoniqish ko\'rsatkichlari bilan boshqaramiz.',
        author: 'Sara Jonson',
        role: 'Mijozlar muvaffaqiyati bo\'yicha VP',
        company: 'TechCorp Inc.'
      },
      {
        quote: 'AI-agentimizni sozlash daqiqalar davom etdi, haftalar emas. ROI darhol edi.',
        author: 'Maykl Chen',
        role: 'Operatsiyalar direktori',
        company: 'GlobalRetail'
      },
      {
        quote: 'Ovoz sifati ajoyib. Mijozlarimiz ko\'pincha AI bilan gaplashayotganini tushunishmaydi.',
        author: 'Emili Rodriges',
        role: 'Bosh direktor',
        company: 'StartupXYZ'
      }
    ]
  },

  // Pricing Page
  pricing: {
    title: 'Oddiy va shaffof narxlar',
    subtitle: 'Biznesingizga mos keladigan rejani tanlang',
    monthly: 'Oylik',
    yearly: 'Yillik',
    save: '20% tejash',
    perMonth: '/oy',
    perYear: '/yil',
    getStarted: 'Boshlash',
    contactSales: 'Savdo bo\'limi bilan bog\'lanish',
    mostPopular: 'Eng mashhur',
    features: 'Xususiyatlar',
    plans: {
      starter: {
        name: 'Boshlang\'ich',
        price: '$49',
        description: 'Kichik bizneslar uchun ideal',
        features: [
          '1 ovozli AI-agent',
          '500 daqiqa/oy',
          'Asosiy analitika',
          'Email orqali qo\'llab-quvvatlash',
          'Standart ovozlar'
        ]
      },
      professional: {
        name: 'Professional',
        price: '$149',
        description: 'Yuqori hajmli o\'sib borayotgan bizneslar uchun',
        features: [
          '5 ovozli AI-agent',
          '2,500 daqiqa/oy',
          'Kengaytirilgan analitika',
          'Ustuvor qo\'llab-quvvatlash',
          'Premium ovozlar',
          'CRM integratsiyalari',
          'Qo\'ng\'iroqni yozib olish'
        ]
      },
      enterprise: {
        name: 'Korporativ',
        price: 'Maxsus',
        description: 'Maxsus ehtiyojlarga ega yirik tashkilotlar uchun',
        features: [
          'Cheksiz AI-agentlar',
          'Cheksiz daqiqalar',
          'Maxsus analitika',
          'Ajratilgan qo\'llab-quvvatlash',
          'Maxsus ovozlar',
          'To\'liq API kirish',
          'SLA kafolati',
          'Mahalliy joylashtiruv'
        ]
      }
    }
  },

  // Contact Us Page
  contactUs: {
    title: 'Biz bilan bog\'laning',
    subtitle: 'Jamoamiz bilan bog\'laning',
    form: {
      name: 'Ismingiz',
      email: 'Email manzil',
      company: 'Kompaniya nomi',
      phone: 'Telefon raqami',
      subject: 'Mavzu',
      message: 'Xabaringiz',
      submit: 'Xabar yuborish',
      sending: 'Yuborilmoqda...',
      success: 'Xabar muvaffaqiyatli yuborildi! Tez orada siz bilan bog\'lanamiz.',
      error: 'Xabarni yuborib bo\'lmadi. Iltimos, qaytadan urinib ko\'ring.'
    },
    info: {
      title: 'Bog\'lanish',
      description: 'Savollaringiz bormi? Sizdan eshitishni xohlaymiz.',
      email: 'support@aiconneqtors.com',
      phone: '+1 (888) 123-4567',
      address: 'San-Fransisko, Kaliforniya'
    }
  },

  // User Login Page
  userLogin: {
    title: 'Agent kirish',
    subtitle: 'Agent paneliga kiring',
    username: 'Foydalanuvchi nomi',
    password: 'Parol',
    signIn: 'Kirish',
    signingIn: 'Kirilmoqda...',
    forgotPassword: 'Parolni unutdingizmi?',
    noAccount: 'Hisobingiz yo\'qmi?',
    contactAdmin: 'Administrator bilan bog\'laning'
  },

  // Sign Up Page
  signUp: {
    title: 'Hisobingizni yarating',
    subtitle: 'Bugun bepul sinov versiyasini boshlang',
    name: 'To\'liq ism',
    email: 'Email manzil',
    password: 'Parol',
    confirmPassword: 'Parolni tasdiqlang',
    company: 'Kompaniya nomi',
    phone: 'Telefon raqami',
    createAccount: 'Hisob yaratish',
    creating: 'Hisob yaratilmoqda...',
    haveAccount: 'Hisobingiz bormi?',
    signIn: 'Kirish',
    terms: 'Ro\'yxatdan o\'tish orqali siz Xizmat shartlari va Maxfiylik siyosatiga rozilik bildirasiz'
  },

  // Admin Login
  adminLogin: {
    title: 'Admin kirish',
    subtitle: 'Boshqaruv paneliga kirish',
    username: 'Foydalanuvchi nomi',
    password: 'Parol',
    signIn: 'Kirish',
    signingIn: 'Kirilmoqda...'
  },

  // Integrations Page
  integrationsPage: {
    title: 'Integratsiyalar',
    subtitle: 'AIConneqtors-ni sevimli vositalaringiz bilan ulang',
    searchPlaceholder: 'Integratsiyalarni qidirish...',
    categories: {
      all: 'Hammasi',
      crm: 'CRM',
      communication: 'Aloqa',
      analytics: 'Analitika',
      automation: 'Avtomatlashtirish'
    },
    connectButton: 'Ulash',
    connectedBadge: 'Ulangan',
    learnMore: 'Batafsil'
  },

  // Documentation Page
  documentation: {
    title: 'Hujjatlar',
    subtitle: 'AIConneqtors bilan ishlashni boshlash uchun zarur hamma narsa',
    searchPlaceholder: 'Hujjatlarni qidirish...',
    gettingStarted: 'Boshlash',
    apiReference: 'API ma\'lumotnomasi',
    guides: 'Qo\'llanmalar',
    tutorials: 'O\'quv materiallari',
    faq: 'Tez-tez so\'raladigan savollar'
  },

  // Releases Page
  releases: {
    title: 'Reliz eslatmalari',
    subtitle: 'Eng so\'nggi xususiyatlar va yaxshilanishlardan xabardor bo\'ling',
    version: 'Versiya',
    date: 'Chiqarilgan',
    newFeatures: 'Yangi xususiyatlar',
    improvements: 'Yaxshilanishlar',
    bugFixes: 'Xatolar tuzatishlari'
  }
};

export default uz;
